import React, { useEffect, useMemo, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { useLocation, useSearchParams } from "react-router-dom";
import Table from "../../../components/Table/Table"
import LinearProgress from "@mui/material/LinearProgress"
import axios from "axios"
import { Link } from "react-router-dom"
import Button from "@mui/material/Button"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import { logOut } from "../../../utils/logOut"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import TablePagination from "@mui/material/TablePagination"
import { Fade, Typography } from "@mui/material"
import TranslatedText from "../../../utils/Translate"
import SimplifiedTable from "../../../components/Table/SimpleTable"
import { useSnackbar } from "../../../utils/SnackbarContext"
import { useSelector } from "react-redux"
import { useRef } from "react";



export default function PrerecordedAudioSnippets() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [tableData, setTableData] = useState([])
    const [startRow, setStartRow] = useState(0)
    const [pageRows, setPageRows] = useState(100)
    const [maxRows, setMaxRows] = useState(pageRows)
    const [totalRows, setTotalRows] = useState(0)
    const [loading, setLoading] = useState(false)
    const [conversationtemplates, setConversationtemplates] = useState([])
    const [voices, setVoices] = useState([])

    const [searchParams, setSearchParams] = useSearchParams();
    const id = searchParams.get("id");

    // флаг, чтобы применить id только один раз за жизнь компонента
    const idAppliedRef = useRef(false);

    const [filterParams, setFilterParams] = useState(localStorage.getItem('prerecordedspeech_filter') ? JSON.parse(localStorage.getItem('prerecordedspeech_filter') || '{}') : {
        conversationtemplate: '',
        sort: 'datetimeproduceddown',
        voice: '',
        color: '',
        transcript: '',
        code: ''
    })


    const { showSnackbar } = useSnackbar();

    useEffect(() => {
        dispatch(setCurrentPage(`Prerecorded Audio Snippets`))
    }, [dispatch]);

    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )


    function saveFilterData() {
        localStorage.setItem('prerecordedspeech_filter', JSON.stringify(filterParams))

    }

    async function fetchPrerecordedIDData(id: any) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/prerecordedspeech/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: {}
            })

            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    return {
                        ...filterParams,
                        voice: response.data[0].voice,
                        transcript: response.data[0].transcript,
                    }
                }

                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Get prerecordedspeech data

    async function fetchData() {
        setLoading(true);
        try {
            let params: any = { ...filterParams, startRow, maxRows, calculatetotalcount: true };

            if (id && !idAppliedRef.current) {
                const newparams = await fetchPrerecordedIDData(id);
                if (newparams) {
                    params = { ...newparams, startRow, maxRows, calculatetotalcount: true };
                    setFilterParams(newparams);
                    saveFilterData();

                    // помечаем, что id уже применён
                    idAppliedRef.current = true;

                    // УДАЛЯЕМ id корректно, через react-router
                    const next = Object.fromEntries(searchParams.entries());
                    delete next.id;
                    setSearchParams(next, { replace: true });
                }
            }

            const response = await axios.get(
                `https://cardgarantsales.com/restapi/prerecordedspeech`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + localStorage.getItem("access_token"),
                    },
                    params,
                }
            );

            if (response.data !== null && typeof response.data === "object") {
                setTotalRows(+response.data[0].totalcount);
                setTableData(response.data.slice(1));
            } else {
                alert(response.data);
            }
        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") logOut(dispatch);
            else if (error.code === "ERR_NETWORK") showSnackbar("ERROR NETWORK", "error");
        } finally {
            setLoading(false);
        }
    }

    //Get conversationtemplate for Select field
    async function getConversationtemplates(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/conversationtemplate`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data.filter((el: any) => el.showsetuptopartner == '1'));
            setConversationtemplates(accesslevel != 5 ? response.data.filter((el: any) => el.showsetuptopartner == '1') : response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Get prerecordedvoices for Select field
    async function getVoices(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/prerecordedvoices`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setVoices(response.data)
                }
                else alert(response.data)
            }
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //on load - fetch data
    useEffect(() => {
        setTimeout(() => fetchData(), 0)
        getConversationtemplates()
        getVoices()
    }, [startRow, maxRows])

    useEffect(() => {
        setMaxRows(pageRows)
        setStartRow(0)
    }, [filterParams])

    //Pagination buttons
    function handleBack() {
        if ((startRow - pageRows) < 0) {
            setStartRow(0)
            setMaxRows(pageRows)

        }
        else {
            setStartRow((prev) => prev - pageRows)
            setMaxRows((prev) => prev - pageRows)
        }
    }

    function handleNext() {

        setStartRow((prev) => prev + pageRows)
        setMaxRows((prev) => prev + pageRows)

    }

    function handleEnd() {

        setStartRow(totalRows % pageRows === 0 ? totalRows - pageRows : totalRows - (totalRows % pageRows))
        setMaxRows(totalRows % pageRows === 0 ? totalRows : totalRows - (totalRows % pageRows) + pageRows)

    }

    function handleStart() {

        setStartRow(0)
        setMaxRows(pageRows)

    }

    const totalPages = Math.ceil(totalRows / pageRows);
    const currentPage = Math.ceil(maxRows / pageRows);
    //exclusion of unnecessary table renderers
    const memoizedTable = useMemo(() => <SimplifiedTable rows={tableData} page={'prerecordedaudiosnippet'} />, [tableData]);

    return (
        <Box sx={{ height: '86vh', display: 'flex', flexDirection: 'column', mr: 1 }}>
            <Box sx={{ mb: 3, alignItems: "center", display: 'flex', width: "100vw", justifyContent: "center" }}>
                <Link to='/prerecordedaudiosnippet' state={{ type: 'add' }}>
                    <Button size="small" sx={{ mr: '2vw', width: 220 }} variant="outlined"><TranslatedText text={'Add'} /></Button>
                </Link>
                <Box sx={{ display: "flex", flexWrap: 'wrap', alignItems: "center", gap: 2, }}>
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Sort'} /></InputLabel>
                        <Select sx={{ width: '12vw', minWidth: 223 }} labelId="simple-select-label" value={filterParams.sort} onChange={(e) => setFilterParams({ ...filterParams, sort: e.target.value })} variant="outlined" size="small" label={<TranslatedText text={'Sort'} />} >
                            <MenuItem selected value={''}><TranslatedText text={'Default'} /> (^<TranslatedText text={'Conversation Template'} /> + v<TranslatedText text={'Transcript'} />)</MenuItem>
                            <MenuItem value={'datetimeproducedup'}>^<TranslatedText text={'date'} />/<TranslatedText text={'time'} /></MenuItem>
                            <MenuItem value={'datetimeproduceddown'}>v<TranslatedText text={'date'} />/<TranslatedText text={'time'} /></MenuItem>
                            <MenuItem value={'audiolengthup'}>^<TranslatedText text={'Duration'} /></MenuItem>
                            <MenuItem value={'audiolengthdown'}>v<TranslatedText text={'Duration'} /></MenuItem>
                            <MenuItem value={'conversationtemplateup'}>^<TranslatedText text={'Conversation template'} /></MenuItem>
                            <MenuItem value={'conversationtemplatedown'}>v<TranslatedText text={'Conversation template'} /></MenuItem>
                            <MenuItem value={'voiceup'}>^<TranslatedText text={'voice'} /></MenuItem>
                            <MenuItem value={'voicedown'}>v<TranslatedText text={'voice'} /></MenuItem>
                            <MenuItem value={'codeup'}>^<TranslatedText text={'Audio segment code'} /></MenuItem>
                            <MenuItem value={'codedown'}>v<TranslatedText text={'Audio segment code'} /></MenuItem>
                            <MenuItem value={'transcriptup'}>^<TranslatedText text={'Transcript'} /></MenuItem>
                            <MenuItem value={'transcriptdown'}>v<TranslatedText text={'Transcript'} /></MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Conversation template'} /></InputLabel>
                        <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setFilterParams({ ...filterParams, conversationtemplate: e.target.value })} value={filterParams.conversationtemplate} variant="outlined" size="small" label={<TranslatedText text={'Conversation template'} />} >
                            <MenuItem value={''}><TranslatedText text={'Not Selected'} /></MenuItem>
                            {
                                conversationtemplates.map((el: any) => (
                                    <MenuItem key={el.id} value={el.id}>{el.conversationtemplatecode}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Voice'} /></InputLabel>
                        <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setFilterParams({ ...filterParams, voice: e.target.value })} value={filterParams.voice} variant="outlined" size="small" label={<TranslatedText text={'Voice'} />} >
                            <MenuItem value={''}><TranslatedText text={'Not Selected'} /></MenuItem>
                            {
                                voices.map((el: any) => (
                                    <MenuItem key={el.id} value={el.voicecode}>{el.voicename}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Color'} /></InputLabel>
                        <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setFilterParams({ ...filterParams, color: e.target.value })} value={filterParams.color} variant="outlined" size="small" label={<TranslatedText text={'Color'} />} >
                            <MenuItem value={''}><TranslatedText text={'Not Selected'} /></MenuItem>
                            <MenuItem value={'red'}><TranslatedText text={'Red'} /> (<TranslatedText text={'with transcript'} />, <TranslatedText text={'without audio'} />)</MenuItem>
                            <MenuItem value={'yellow'}><TranslatedText text={'Yellow'} /> (<TranslatedText text={'without transcript'} />, <TranslatedText text={'without audio'} />)</MenuItem>
                            <MenuItem value={'green'}><TranslatedText text={'Green'} /> (<TranslatedText text={'with audio'} />)</MenuItem>
                        </Select>
                    </FormControl>
                    {/* <TextField  defaultValue={''} onBlur={(e) => setFilterParams({ ...filterParams, maxRows: e.target.value })} sx={{ mr: 2, minWidth: 223 }} variant="outlined" size="small" label='MaxRows' /> */}
                    <TextField defaultValue={''} onBlur={(e) => setFilterParams({ ...filterParams, code: e.target.value })} sx={{ minWidth: 223 }} variant="outlined" size="small" label={<TranslatedText text={'Audio fragment code'} />} />
                    <TextField key={filterParams.transcript+1} defaultValue={filterParams.transcript || ''} onBlur={(e) => setFilterParams({ ...filterParams, transcript: e.target.value })} sx={{ minWidth: 223 }} variant="outlined" size="small" label={<TranslatedText text={'Transcript'} />} />
                    <Button onClick={() => { fetchData(); saveFilterData() }} size="small" sx={{ mr: 1 }} variant="contained" ><TranslatedText text={'Apply'} /></Button>
                </Box>
                <Box></Box>
            </Box>
            {loading ? <LinearProgress sx={{ width: "50%", marginTop: '33vh', marginLeft: 'auto', marginRight: 'auto' }} /> :
                <>
                    {memoizedTable}
                    <Fade in={!loading} timeout={300}>
                        <Box sx={{ display: 'flex', alignItems: "center", marginTop: 'auto' }}>
                            <Box sx={{ mt: 2 }}>
                                <Button disabled={startRow === 0} onClick={() => handleStart()} size="small" sx={{ mr: 1 }} variant="outlined" >{"<<"}</Button>
                                <Button disabled={startRow === 0} onClick={() => handleBack()} size="small" sx={{ mr: 1 }} variant="outlined" ><span>{'<'}&nbsp;</span> {<TranslatedText text={"Back"} />}</Button>
                                <Button disabled={maxRows >= totalRows} onClick={() => handleNext()} size="small" sx={{ mr: 1 }} variant="outlined" >{<TranslatedText text={'Next'} />}&nbsp;<span>{'>'}</span></Button>
                                <Button disabled={maxRows >= totalRows || tableData.length < pageRows} onClick={() => handleEnd()} size="small" sx={{ mr: 1 }} variant="outlined" >{">>"}</Button>
                            </Box>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Rows on page:'} /> {pageRows}</Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}>
                                <TranslatedText text={'Page:'} /> {currentPage} / {totalPages}
                            </Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Total rows:'} /> {totalRows}</Typography>
                        </Box>
                    </Fade>
                </>}
        </Box>
    )
}